/**
 * Web-only measures — NOT part of the mobile theme mirror. `theme/tokens.ts`
 * is a hand-kept copy of `mobile/theme/tokens.ts` and must stay byte-level in
 * step; these values exist only on the web (page measures, chip radii for
 * marketing chrome) and would be wrong to "sync" in either direction.
 */
import { radius } from "@/theme/tokens";

/** Long-form prose measure: hero subheadline, ledes, captions, zettel copy. */
export const PROSE_MEASURE = 620;

/** Wider panel measure: section heads, the later/ownership panels. */
export const PANEL_MEASURE = 680;

/** The marketing chips' rounding, shared by how-it-works and the privacy rail. */
export const CHIP_RADIUS = radius.sm + 4;
